var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.type,{tag:"div",on:{"touchstart":_vm.touchStart,"touchend":_vm.touchStop,"touchcancel":_vm.touchStop,"touchmove":_vm.touchStop}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }